import styled from 'styled-components';

import { baseInputStyles } from 'pods/forms/components/inputs/Text/Text.style';

export const TextArea = styled.textarea`
	${props => baseInputStyles(props)}
	height: 120px;
	resize: vertical;
	min-height: 120px;
	max-height: 300px;
	max-width: 800px;
	width: 100%;
	white-space: pre-wrap;

	/* Hide the microsoft default 'clear' button */
	&::-ms-clear {
		display: none;
	}
`;

export const RemainingCharacters = styled.div`
	margin-top: 10px;
	font-size: 14px;
`;

export default TextArea;
